//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, useEffect, useState } from "react"
import { useParams } from 'react-router';
import { Outlet } from "react-router-dom";

// === CONTANTS ===
import { RULE_STATUS } from "constants/general";

// === API ===
import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

const ContextAnalytics = createContext();

const review_options = {
  FAILED    : { label: 'Failed'   , value: RULE_STATUS.FAILED    },
  PASSED    : { label: 'Passed'   , value: RULE_STATUS.PASSED    },
  OVERRULED : { label: 'Overruled', value: RULE_STATUS.OVERRULED },
};

//-----------------------------------------------------------------
export function AnalyticsProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const route_params = useParams();
  const file_id = parseInt( route_params.file_id );
  
  const [   file_name, setFileName   ] = useState( '' );
  const [       stats, setStats      ] = useState( { open: '-', closed: '-', total: '-'} );
  const [   documents, setDocuments  ] = useState( [] );
  const [       rules, setRules      ] = useState( [] );
  const [review_flags, setReviewFlags] = useState( [RULE_STATUS.FAILED]);
  const [  is_loading, setIsLoading  ] = useState(false);

  const [ task, setTask ] = useState( null );

  const values = {
    file_id, file_name,
    documents, rules, stats,
    task, clearTask,
    review_flags, setReviewFlags, review_options,
    is_loading  , setIsLoading  ,
  };

  //#endregion

  //#region [EFFECT]
  
  useEffect( () => {
    //-----------------------------------------------------------------
    function listener_file(data) {
      //-----------------------------------------------------------------
      if ( data === null ) {
        // navigate('/analytics/files');
        return;
      }

      setFileName ( data.loan_number );
      setDocuments( data.packages    );
      setRules    ( data.rules || [] );
      setStats    ( { open: data.num_open, closed: data.num_closed } );

      setIsLoading( false );
    }
    //-----------------------------------------------------------------    
    function handleTask(data) {
      //-----------------------------------------------------------------
      setTask(data)
    }

    on( 'FILE'       , listener_file );
    on( 'AUDIT-TASK' , handleTask    );
    
    return () => {
      removeListener( 'FILE'        , listener_file );
      removeListener( 'AUDIT-TASKE' , handleTask    );
    };
  }, [] ); // empty dependency = called only once at startup
  
  useEffect( () => {
    return () => {
      sendMessageData( 'FILE_ANALYTICS_CLOSE', { file_id } )
    }
  }, [file_id] )
  
  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []); // empty dependency = called only once at startup

  //#endregion
  
  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if(false) {}
    // Comparison Image
    else if ( event.key === 'PageUp' && event.shiftKey ) {
      event.preventDefault();
      event.stopPropagation();
    }
    else if ( event.key === 'PageDown' && event.shiftKey ) {
      event.preventDefault();
      event.stopPropagation();
    }
    // Primary Image
    else if ( event.key === 'PageUp' ) {
      event.preventDefault();
      event.stopPropagation();
    }
    else if ( event.key === 'PageDown' ) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  //#endregion

  //#region [MODIFY]

  function clearTask() {
    setTask( null );
  }

  //#endregion


  return (
    <ContextAnalytics.Provider value={ values }>
      <Outlet />
    </ContextAnalytics.Provider>
  );
};

//-----------------------------------------------------------------
export function useAnalytics() {
  //-----------------------------------------------------------------
  return useContext( ContextAnalytics );
}